import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router';

import { router } from '@/app/routes/router';
import { authGetCsrf } from '@/features/auth/api/auth-api';
import { ToastHost } from '@/shared/components/ToastHost';

export function App() {
  useEffect(() => {
    void authGetCsrf().catch(() => {
      // Ignore CSRF bootstrap failures; requests will surface actionable errors.
    });
  }, []);

  return (
    <HelmetProvider>
      <RouterProvider router={router} />
      <ToastHost />
    </HelmetProvider>
  );
}
